<template lang="pug">
  .box-search
    span.label 設定{{ index + 1}}
    span.updated 更新日 : {{ condition.updatedAt }}
    h4 {{ condition.name }}
    ul
      li
        span 掲載メディア
        | {{ condition.media | normalize }}
      li
        span 所在地
        | {{ condition.prefectures | normalize }}
        br
        | {{ condition.cities | normalize }}
      li
        span 勤務地
        | {{ condition.workPlacePrefectures | normalize }}
        br
        | {{ condition.workPlaceCities | normalize }}
      li
        span 業種
        | {{ condition.industries | normalize }}
      li
        span キーワードその他
        | {{ condition.condition.keyword | normalize }}
      li
        span 除外キーワード
        | {{ condition.condition.excludeKeyword | normalize }}
      li
        span 掲載状況
        | {{ condition.situation | normalize }}
      li
        span 掲載開始日
        | {{ condition.acquisitionDate | normalize }}
      li(v-if="condition.condition.acquisitionDate == 4")
        | {{ condition.condition.fromAcquisitionDate }} 〜 {{ condition.condition.toAcquisitionDate }}
    p.buttons
      input.button-main(type="button", value="検索", @click.prevent="search")
    p.buttons.job-notification-button(v-if="user.has_basic && user.new_job_notification")
      input.button-main(type="button", value="メール通知設定", @click="showJobNotificationSettingModal")
    .box-mylist-delete
      a(@click.prevent="destroy") 削除する
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { HumanInfoMessages, DefaultOrder, DefaultOrderDirection } from '../../constants'

  const splitter = '、'
  const placeHolder = '-'

  export default {
    props: ['condition', 'index'],
    computed: {
      ...mapGetters('searchCondition', ['builtQuery']),
      id () {
        return this.condition.id
      },
      ...mapState({
        user: state => state.user.detail,
      }),
    },
    methods: {
      search () {
        const query = this.condition.condition
        const apiQuery = {
                         mediaCd: query.mediaCd.map(m => (m.value || m)).join(','),
                         prefectureCd: query.prefectureCd.map(p => (p.value || p)).join(','),
                         cityCd: query.cityCd.map(p => (p.value || p)).join(','),
                         workPlacePrefectureCd: query.workPlacePrefectureCd === undefined ? '' : query.workPlacePrefectureCd.map(p => (p.value || p)).join(','),
                         workPlaceCityCd: query.workPlaceCityCd === undefined ? '' : query.workPlaceCityCd.map(p => (p.value || p)).join(','),
                         stationKeyword: query.stationKeyword,
                         jobtypeCd: query.jobtypeCd.map(t => (t.value || t)).join(','),
                         industryCd: query.industryCd.map(i => (i.value || i)).join(','),
                         viewEndDate: query.viewEndDate,
                         acquisitionDate: query.acquisitionDate,
                         selectedIntroductionCompany: query.selectedIntroductionCompany,
                         excludedTemporaryStaffing: query.excludedTemporaryStaffing,
                         excludedNoCompanyTel: query.excludedNoCompanyTel,
                         excludedNoCompanyUrl: query.excludedNoCompanyUrl,
                         applyKeywordsToCatchcopy: query.applyKeywordsToCatchcopy,
                         applyKeywordsToJobtypeName: query.applyKeywordsToJobtypeName,
                         applyKeywordsToJobContents: query.applyKeywordsToJobContents,
                         applyKeywordsToQualification: query.applyKeywordsToQualification,
                         applyKeywordsToCompanyName: query.applyKeywordsToCompanyName,
                         applyExcludeKeywordsToCatchcopy: query.applyExcludeKeywordsToCatchcopy,
                         applyExcludeKeywordsToJobtypeName: query.applyExcludeKeywordsToJobtypeName,
                         applyExcludeKeywordsToJobContents: query.applyExcludeKeywordsToJobContents,
                         applyExcludeKeywordsToQualification: query.applyExcludeKeywordsToQualification,
                         applyExcludeKeywordsToCompanyName: query.applyExcludeKeywordsToCompanyName,
                         prPointCd: query.prPointCd.map(pp => (pp.value || pp)).join(','),
                         salaryCd: query.salaryCd,
                         salaryMin: query.salaryMin,
                         salaryMax: query.salaryMax,
                         employmentCd: query.employmentCd.map(ec => (ec.value || ec)).join(','),
                         budgetLower: query.budgetLower,
                         budgetUpper: query.budgetUpper,
                         companyName: query.companyName,
                         hakenCompanyName: query.hakenCompanyName,
                         companyId: query.companyId,
                         stationId: query.stationId,
                         keyword: query.keyword === undefined || query.keyword === '' ? '' : query.keyword.map(i => (i.value || i)).join(','),
                         excludeKeyword: query.excludeKeyword === undefined || query.keyword === '' ? '' : query.excludeKeyword.map(i => (i.value || i)).join(','),
                         order: DefaultOrder,
                         orderDirection: DefaultOrderDirection,
                         fromAcquisitionDate: query.fromAcquisitionDate,
                         toAcquisitionDate: query.toAcquisitionDate,
                       }
        this.$router.push({
          name: query.haken ? 'SearchHaken' : 'SearchJob',
          query: apiQuery,
        })
      },
      async destroy () {
        // eslint-disable-next-line
        if (!confirm(HumanInfoMessages.DO_DESTROY.replace('%s', this.condition.name))) {
          return
        }

        this.$store.commit('common/lockGlobal')
        try {
          await this.$store.dispatch('searchCondition/destroy', { id: this.id })
          this.$store.dispatch('common/pushToastInfo', { info: HumanInfoMessages.SEARCH_CONDITION_DESTROYED })
        } catch (e) {
          this.$store.dispatch('common/pushToastError', { error: e })
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
      async showJobNotificationSettingModal () {
        this.$store.dispatch('jobNotificationSetting/fetchIndex')
        this.$store.dispatch('jobNotificationSetting/setConditions', this.condition)
        this.$store.commit('jobNotificationSetting/showJobNotificationSettingModal')
      },
    },
    filters: {
      normalize (v) {
        if (Array.isArray(v)) {
          if (v.length) {
            return v.length > 20
              ? `${v.slice(0, 20).join(splitter)} 他`
              : v.join(splitter)
          }
          return placeHolder
        }

        return v || placeHolder
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/SearchCondition.vue